import { SpacesList } from './spaces-list.js';

/**
 * List of all the available technical space types
 */
const AllSpaceTypes = Array.from(new Set(SpacesList.map(s => s.spaceType).filter(t => t !== undefined)));

export { AllSpaceTypes };
//# sourceMappingURL=rg-space-type-list.js.map
